module.exports = __webpack_public_path__ + "img/service-bg-m.b02a7934.png";